import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import IdleLogout from "./components/IdleLogout";
import ServerRestartLogout from "./components/ServerRestartLogout";
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UserPage from "./pages/admin/UserPage";
import ServicePlans from "./pages/admin/ServicePlans";
import ReportsPage from "./pages/admin/ReportsPage";
import SessionMonitor from "./pages/admin/SessionMonitor";
import Analytics from "./pages/admin/Analytics";
import Billing from "./pages/admin/Billing";
import ApiKeys from "./pages/admin/ApiKeys";
import ActivityLogs from "./pages/admin/ActivityLogs";
import Settings from "./pages/admin/Settings";
import ClientDashboard from "./pages/client/ClientDashboard";
import WhatsAppConnect from "./pages/client/WhatsAppConnect";
import BulkMessage from "./pages/client/BulkMessage";
import AutoReply from "./pages/client/AutoReply";
import Contacts from "./pages/client/Contacts";
import ClientSettings from "./pages/client/ClientSettings";
import PlanRenewal from "./pages/client/PlanRenewal";
import MessageReport from "./pages/client/MessageReport";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  return (
    <ErrorBoundary>
      <IdleLogout timeoutMs={3 * 60 * 1000} />
      <ServerRestartLogout pollMs={120_000} />
      <BrowserRouter>
        <Routes>
          {/* Login Page */}
          <Route path="/login" element={<Login />} />

        {/* ADMIN ROUTES (Protected) */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute role="ADMIN">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute role="ADMIN">
              <UserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sessions"
          element={
            <ProtectedRoute role="ADMIN">
              <SessionMonitor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/plans"
          element={
            <ProtectedRoute role="ADMIN">
              <ServicePlans />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/billing"
          element={
            <ProtectedRoute role="ADMIN">
              <Billing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute role="ADMIN">
              <Analytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/api-keys"
          element={
            <ProtectedRoute role="ADMIN">
              <ApiKeys />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/logs"
          element={
            <ProtectedRoute role="ADMIN">
              <ActivityLogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <ProtectedRoute role="ADMIN">
              <ReportsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute role="ADMIN">
              <Settings />
            </ProtectedRoute>
          }
        />

        {/* CLIENT ROUTES (With Protection) */}
        <Route
          path="/client/dashboard"
          element={
            <ProtectedRoute role="CLIENT">
              <ClientDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/whatsapp"
          element={
            <ProtectedRoute role="CLIENT">
              <WhatsAppConnect />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/bulk"
          element={
            <ProtectedRoute role="CLIENT">
              <BulkMessage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/auto-reply"
          element={
            <ProtectedRoute role="CLIENT">
              <AutoReply />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/contacts"
          element={
            <ProtectedRoute role="CLIENT">
              <Contacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/reports"
          element={
            <ProtectedRoute role="CLIENT">
              <MessageReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/settings"
          element={
            <ProtectedRoute role="CLIENT">
              <ClientSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/plan-renewal"
          element={
            <ProtectedRoute role="CLIENT">
              <PlanRenewal />
            </ProtectedRoute>
          }
        />

        {/* Default Redirects */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
    </ErrorBoundary>
  );
}